(() => {
  if (window.monocoHomeReady) return;
  window.monocoHomeReady = true;
  const config = JSON.parse(document.getElementById('MonocoHomeConfig')?.textContent || '{}');
  const keys = { recent: 'monoco_home_recent_v1', favourites: 'monoco_home_favourites_v1' };
  const validHandle = value => typeof value === 'string' && /^[a-z0-9\-\u0080-\uFFFF]+$/i.test(value);
  const read = key => { try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(validHandle).slice(0,24) : []; } catch { return []; } };
  const save = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value.slice(0,24))); return true; } catch { return false; } };
  if (validHandle(config.product) && !config.product.endsWith('-standard')) save(keys.recent, [config.product,...read(keys.recent).filter(x => x !== config.product)]);
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  class MonocoCarousel extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const prev = this.querySelector('[data-prev]'); const next = this.querySelector('[data-next]');
        if (prev) prev.disabled = this.track.scrollLeft < 2;
        if (next) next.disabled = this.track.scrollLeft >= maximum - 2;
      };
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.move(-1), {signal});
      this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1), {signal});
      this.track.addEventListener('scroll', this.update, {signal, passive:true});
      this.observer = new ResizeObserver(this.update); this.observer.observe(this.track);
      this.mutations = new MutationObserver(this.update);this.mutations.observe(this.track,{childList:true});
      this.update();
    }
    move(direction) { const item = this.track.firstElementChild; if(!item) return; const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0; this.track.scrollBy({left:direction*(item.getBoundingClientRect().width+gap),behavior:reduced()?'instant':'smooth'}); }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect();this.mutations?.disconnect(); }
  }
  if (!customElements.get('monoco-carousel')) customElements.define('monoco-carousel', MonocoCarousel);
  const productCache = new Map();
  const loadProduct = handle => {
    if (!productCache.has(handle)) productCache.set(handle, fetch(`${config.root || '/'}products/${encodeURIComponent(handle)}.js`).then(r => r.ok ? r.json() : null).catch(() => null));
    return productCache.get(handle);
  };
  const money = value => { try {return new Intl.NumberFormat(config.locale || 'ja-JP',{style:'currency',currency:config.currency || 'JPY'}).format(value/100);}catch{return String(value/100);} };
  const element = (tag,cls,text) => {const e=document.createElement(tag);e.className=cls;if(text!==undefined)e.textContent=text;return e;};
  const card = p => {
    const root=element('div','mh-product'),a=element('a','mh-product__link');a.href=`${config.root || '/'}products/${encodeURIComponent(p.handle)}`;
    const box=element('div','mh-product__image');
    if (p.featured_image) { const img=element('img','');img.src=p.featured_image;img.alt=p.title;img.loading='lazy';img.width=600;img.height=600;box.append(img); }
    a.append(box,element('span','mh-product__title',p.title),element('span','mh-product__price',money(p.price)));
    const button=element('button','mh-favourite','♡');button.type='button';button.dataset.favourite=p.handle;button.setAttribute('aria-label',`${p.title}をお気に入りに保存`);button.setAttribute('aria-pressed','false');root.append(a,button);return root;
  };
  const syncButtons = () => {const saved=read(keys.favourites);document.querySelectorAll('[data-favourite]').forEach(b=>{const active=saved.includes(b.dataset.favourite);b.setAttribute('aria-pressed',String(active));b.textContent=active?'♥':'♡';});};
  class MonocoProductRail extends HTMLElement {
    connectedCallback() {this.refresh();}
    async refresh() {
      if(this.dataset.mode==='collection'){syncButtons();return;}
      const version=(this.version || 0)+1;this.version=version;
      const handles=read(keys[this.dataset.mode]).slice(0,Number(this.dataset.limit)||8);
      if(!handles.length){this.hidden=true;return;}
      const products=(await Promise.all(handles.map(loadProduct))).filter(p=>p && !p.tags?.includes('hidden'));
      if(!this.isConnected || this.version!==version)return;
      const track=this.querySelector('[data-track]');if(!track)return;
      track.replaceChildren(...products.map(card));this.hidden=products.length===0;syncButtons();
    }
  }
  if(!customElements.get('monoco-product-rail'))customElements.define('monoco-product-rail',MonocoProductRail);
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-favourite]');if(!button)return;
    const handle=button.dataset.favourite;if(!validHandle(handle))return;
    const current=read(keys.favourites);const next=current.includes(handle)?current.filter(x=>x!==handle):[handle,...current];
    if (!save(keys.favourites,next)) {button.setAttribute('aria-label','このブラウザではお気に入りを保存できません');return;}
    syncButtons();document.querySelectorAll('monoco-product-rail[data-mode="favourites"]').forEach(rail=>rail.refresh());
  });
  addEventListener('storage',event=>{if(Object.values(keys).includes(event.key)){syncButtons();document.querySelectorAll('monoco-product-rail').forEach(rail=>rail.refresh());}});
  document.addEventListener('shopify:section:load',syncButtons);
  syncButtons();
})();
